export const PENDING_STATUSES = [
  'create',
  'pending_create',
  'stop_decom',
  'pending_stop_decom',
  'destroy',
  'pending_destroy',
  'delete',
  'pending_delete',
  'reset',
  'pending_reset',
  'pending_migrate',
  'migrate',
];

export const FAILED_STATUSES_WITH_SYNC_CHECK = [
  'failed_create',
  'failed_decom',
  'failed_destroy',
  'failed_delete',
  'failed_reset',
  'failed_disable',
];
